import React, {useState} from 'react'
import {Link, withRouter} from 'react-router-dom'
import {
  CButton,
  CCard,
  CCardBody,
  CCardGroup,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CRow
} from '@coreui/react'

import {
  INCORRECT_LOGIN_MSG,
  MESSAGE_SIGNUP_FORGOTPASSWORD,
  PASSWORD,
  POOL,
  USERNAME
} from '../../../AppConstants';
import {v4 as uuidv4} from 'uuid';
import {setLoggedInUser, clearLoggedInUser} from '../../../actions';
import store from "../../../store";

async function invokeAuthentication(url, request) {
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-request-id': uuidv4()
    },
    body: JSON.stringify(request)
  })
  .then(data => data.json())
  .catch(error => {
    console.log('Login caught error:', error);
  });
}

const Login = (props) => {
  const [loginField, setLoginField] = useState({
    username: "",
    password: ""
  });
  const [message, setMessage] = useState(props.history.location?.state);

  const handleFieldChange = (event) => {
    const {name, value} = event.target;
    setLoginField({
      ...loginField,
      [name]: value
    });
  }

  const handleSignUpOrForgotPassword = (event) => {
    event.preventDefault();
    setMessage(MESSAGE_SIGNUP_FORGOTPASSWORD);
  }

  const handleLogin = (event) => {
    event.preventDefault();
    setMessage("");

    // explicitly invoke form validation as preventDefault skips it
    let ele = document.getElementById("loginForm");
    let areFieldsValid = ele.checkValidity();
    ele.reportValidity();
    if (areFieldsValid) {
      performAuth();
    }
  }

  const performAuth = async () => {
    let request = {
      [USERNAME]: loginField.username,
      [PASSWORD]: loginField.password,
      [POOL]: process.env.REACT_APP_SESSION_POOL_NAME
    }
    console.log(
      `Authentication submitted with request for Username: ${loginField.username}`);

    const token = await invokeAuthentication(
      process.env.REACT_APP_SESSION_AUTHENTICATION_URL, request);

    if (token?.success) {
      // now capture MFA code
      if (token?.session) {
        let userSession = {
          'session': token?.session,
          'username': loginField.username
        };
        store.dispatch(setLoggedInUser(userSession));
        props.history.push({pathname: "/verifyCode"});
      } else {
        setLoginField({
          username: "",
          password: ""
        });
        setMessage(INCORRECT_LOGIN_MSG);
        store.dispatch(clearLoggedInUser());
      }
    } else {
      setLoginField({
        username: "",
        password: ""
      });
      setMessage(INCORRECT_LOGIN_MSG);
      store.dispatch(clearLoggedInUser());
    }
  }

  return (
    <div
      className="c-app c-default-layout flex-row align-items-center loginPage">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol>
            <CCardGroup className="publicCardGroup">
              <CCard className="p-4 leftImage">
                <CCardBody>
                </CCardBody>
              </CCard>
              <CCard>
                <CCardBody>
                  <CForm id="loginForm">
                    <div className="loginLogo"></div>

                    <div className="small text-muted">Welcome back! Please login
                      to your account.
                    </div>
                    {message &&
                    <div className="invalidField">{message}</div>
                    }
                    <CInputGroup className="mb-3">
                      <CInput type="text"
                              placeholder="Username"
                              name="username"
                              value={loginField.username}
                              onChange={handleFieldChange}
                              minLength="1"
                              maxLength="128" required/>
                    </CInputGroup>
                    <CInputGroup className="mb-4">
                      <CInput type="password"
                              placeholder="Password"
                              name="password"
                              value={loginField.password}
                              onChange={handleFieldChange}
                              minLength="8"
                              maxLength="256" required/>
                    </CInputGroup>
                    <CRow>
                      <CCol xs="6">
                      </CCol>
                      <CCol xs="6" className="text-right">
                        <CButton color="link"
                                 className="px-0">
                          <Link to="#" onClick={handleSignUpOrForgotPassword}>Forgot
                            password?</Link>
                        </CButton>
                      </CCol>
                    </CRow>
                    <CRow className="buttonArea">
                      <CCol xs="6">
                        <CButton color="primary"
                                 type="submit"
                                 className="px-4 btn-lg btn-block"
                                 onClick={handleLogin}>Login</CButton>
                      </CCol>
                      <CCol xs="6" className="text-right">
                        <CButton color="primary"
                                 className="px-4 btn-outline-primary btn-lg btn-block"
                                 onClick={handleSignUpOrForgotPassword}>Sign
                          up</CButton>
                      </CCol>
                    </CRow>
                  </CForm>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default withRouter(Login);
